<template>
  <div v-loading="loading">
    <el-row :gutter="15">
      <el-col :span="12">
        <el-card style="height: 450px;">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>工区出勤率</div>
          <el-row>
            <div class="es-op-box">
              <el-date-picker style="float: left;width:300px;margin-bottom: 10px;"
                              format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"
                              v-model="dateTimeRank"
                              type="daterange"
                              size="small"
                              class="query"
                              range-separator="至"
                              start-placeholder="计划开始日期起始"
                              end-placeholder="计划开始日期结束"
                              clearable
                              @change="() => {
                  loaddistrictList()
                }">
              </el-date-picker>
            </div>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              <div style="height:340px;">
                <el-col>
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ userTopThree != null && userTopThree.length > 0 ? userTopThree[0].workhours : 0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                                  :src="require('../imgs/goldmedal.png')">
                        </el-image>
                        <!-- <i class="el-icon-medal el-icon--left context-icon" style="color:#FFEA04;"></i> -->
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 0 ? userTopThree[0].user_name : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 0 ? userTopThree[0].name : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
                <el-col>
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ userTopThree != null && userTopThree.length > 1 ? userTopThree[1].workhours : 0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                                  :src="require('../imgs/silvermedal.png')">
                        </el-image>
                        <!-- <i class="el-icon-medal el-icon--left context-icon" style="color:#F5F8F0;"></i> -->
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 1 ? userTopThree[1].user_name : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 1 ? userTopThree[1].name : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
                <el-col>
                  <div class="tatistic-dialog-div">
                    <el-row class="tatistic-value">
                      <el-col :span="18">
                        <div style="margin-top: 20px;margin-right: -40px;">
                          {{ userTopThree != null && userTopThree.length > 2 ? userTopThree[2].workhours : 0 }}
                        </div>
                      </el-col>
                      <el-col :span="6">
                        <el-image style="width: 40px; height: 40px;margin-left: -70px;margin-top: 10px;"
                                  :src="require('../imgs/bronzemedal.png')">
                        </el-image>
                        <!-- <i class="el-icon-medal el-icon--left context-icon" style="color:#E8A445;"></i> -->
                      </el-col>
                    </el-row>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 2 ? userTopThree[2].user_name : '' }}
                      </el-row>
                    </el-col>
                    <el-col :span="12">
                      <el-row class="tatistic-key">
                        {{ userTopThree != null && userTopThree.length > 2 ? userTopThree[2].name : '' }}
                      </el-row>
                    </el-col>
                  </div>
                </el-col>
              </div>
            </el-col>
            <el-col :span="16">
              <div style="height:340px;">
                <div id="hoursDate"
                     style="height:320px;width:100%;"></div>
              </div>
            </el-col>

          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card style="height: 450px;">
          <div slot="header"
               class="card-header"><i class="el-icon-s-custom"></i>人员工时</div>
          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="dateTimeDistrict"
                            type="daterange"
                            size="small"
                            class="query"
                            range-separator="至"
                            start-placeholder="计划开始日期起始"
                            end-placeholder="计划开始日期结束"
                            clearable
                            @change="() => {
                loaddistrictList()
              }">
            </el-date-picker>
          </div>
          <el-table :data="districtList"
                    ref="lineTable"
                    border
                    stripe
                    size="mini"
                    height="350">
            <el-table-column prop="workAreaName"
                             label="工区"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         @click="() => { queryObjUser.pageNum = 1; loaduserListByDepart(scope.row.workAreaId) }"
                         type="success">{{
                    scope.row.workAreaName
                  }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="userNum"
                             label="员工总数"
                             align="center">
            </el-table-column>
            <el-table-column prop="userWorkNum"
                             label="日在岗人数"
                             align="center">
            </el-table-column>
            <el-table-column prop="planhours"
                             label="总上岗时间"
                             align="center">
            </el-table-column>
            <el-table-column prop="actualhours"
                             label="实际上岗时间"
                             align="center">
            </el-table-column>
            <el-table-column prop="attendance"
                             label="出勤率"
                             align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.attendance != null">{{ (scope.row.attendance * 100).toFixed(1) }}%</span>
                <span v-else>0%</span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col>
        <el-card id="dapartuserschart"
                 style="height:calc(100vh - 580px);margin-top: 10px;">
          <div class="es-op-box">
            <el-date-picker style="float: left;width:300px;margin-bottom: 10px;"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            v-model="dateTimeUser"
                            type="daterange"
                            size="small"
                            class="query"
                            range-separator="至"
                            start-placeholder="计划开始日期起始"
                            end-placeholder="计划开始日期结束"
                            clearable
                            @change="() => {
                loadUserHoursList()
              }">
            </el-date-picker>
          </div>
          <el-table :data="userHoursList"
                    :span-method="objectSpanMethod"
                    ref="lineHoursTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 650px)">
            <el-table-column prop="work_area_name"
                             label="工区"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         @click="() => { queryObjUserHoursDe.pageNum = 1; loadUserListByHoursDe(scope.row.work_area_id) }"
                         type="success">{{
                    scope.row.work_area_name
                  }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="user_name"
                             label="人员名称"
                             align="center">
            </el-table-column>
            <el-table-column prop="workfauNum"
                             label="完成故障数量"
                             align="center">
            </el-table-column>
            <el-table-column prop="workfauhours"
                             label="故障工时"
                             align="center">
            </el-table-column>
            <el-table-column prop="workinsNum"
                             label="完成巡检数量"
                             align="center">
            </el-table-column>
            <el-table-column prop="workinshours"
                             label="巡检工时"
                             align="center">
            </el-table-column>
            <el-table-column prop="workmaintainNum"
                             label="完成保养数量"
                             align="center">
            </el-table-column>
            <el-table-column prop="workmaintainhours"
                             label="保养工时"
                             align="center">
            </el-table-column>
            <el-table-column prop="worktaskNum"
                             label="完成任务数量"
                             align="center">
            </el-table-column>
            <el-table-column prop="worktaskhours"
                             label="任务工时"
                             align="center">
            </el-table-column>
            <el-table-column prop="workhours"
                             label="总工时"
                             align="center">
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <!--查看详情-->
    <el-dialog :visible.sync="viewVisible"
               width="700px"
               style="padding-top: 0px;">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>员工工时
      </span>
      <el-table :data="userPageData.list"
                ref="itemTable"
                border
                stripe
                size="mini"
                height="500"
                v-loading="loading">
        <el-table-column type="index"
                         label="序号"
                         width="50">
        </el-table-column>
        <el-table-column prop="user_name"
                         label="人员名称">
        </el-table-column>
        <el-table-column prop="planhours"
                         label="定额上岗时间">
        </el-table-column>
        <el-table-column prop="actualhours"
                         label="实际上岗时间">
        </el-table-column>
        <el-table-column prop="planday"
                         label="计划出勤天数">
        </el-table-column>
        <el-table-column prop="actualday"
                         label="实际出勤天数">
        </el-table-column>
        <el-table-column prop="attendance"
                         label="出勤率">
          <template slot-scope="scope">
            <span v-if="scope.row.attendance != null">{{ (scope.row.attendance * 100).toFixed(1) }}%</span>
            <span v-else>0%</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="es-page-box">
        <es-pagination :data="userPageData"
                       @change="(cpage) => { this.queryObjUser.pageNum = cpage; this.loaduserListByDepart(this.workAreaId) }">
        </es-pagination>
      </div>
      <span slot="footer">
        <el-button size="mini"
                   type="primary"
                   @click="() => { queryObjUser.pageNum = 1; viewVisible = false }">关
          闭</el-button>
      </span>
    </el-dialog>
    <!--查看详情-->
    <el-dialog :visible.sync="viewHourVisible"
               width="1100px"
               style="padding-top: 0px;">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>员工详情
      </span>
      <el-table :data="userHoursPageData.list"
                ref="itemTable"
                border
                stripe
                size="mini"
                height="600"
                v-loading="loading">
        <el-table-column type="index"
                         label="序号"
                         width="50">
        </el-table-column>
        <el-table-column prop="user_name"
                         label="人员名称"
                         align="center">
        </el-table-column>
        <el-table-column prop="workfauNum"
                         label="完成故障数量"
                         align="center">
        </el-table-column>
        <el-table-column prop="workfauhours"
                         label="故障工时"
                         align="center">
        </el-table-column>
        <el-table-column prop="workinsNum"
                         label="完成巡检数量"
                         align="center">
        </el-table-column>
        <el-table-column prop="workinshours"
                         label="巡检工时"
                         align="center">
        </el-table-column>
        <el-table-column prop="workmaintainNum"
                         label="完成保养数量"
                         align="center">
        </el-table-column>
        <el-table-column prop="workmaintainhours"
                         label="保养工时"
                         align="center">
        </el-table-column>
        <el-table-column prop="worktaskNum"
                         label="完成任务数量"
                         align="center">
        </el-table-column>
        <el-table-column prop="worktaskhours"
                         label="任务工时"
                         align="center">
        </el-table-column>
        <el-table-column prop="workhours"
                         label="总工时"
                         align="center">
        </el-table-column>
      </el-table>
      <div class="es-page-box">
        <es-pagination :data="userHoursPageData"
                       @change="(cpage) => { this.queryObjUserHoursDe.pageNum = cpage; this.loadUserListByHoursDe(this.workAreaIdHour) }">
        </es-pagination>
      </div>
      <span slot="footer">
        <el-button size="mini"
                   type="primary"
                   @click="() => { queryObjUserHoursDe.pageNum = 1; viewHourVisible = false }">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dateutils from '../../utils/dateutils.js'
export default {
  name: 'userstatistic',
  data () {
    return {
      queryObj: { starttime: [], endtime: [] },//查询条件
      queryObjUser: { pageNum: 1, pageSize: 20, starttime: [], endtime: [], orderBy: 'plan.actualhours DESC' },//查询条件
      pageData: {},
      districtList: [],
      userPageData: {},
      queryObjHours: { pageNum: 1, pageSize: 3, starttime: [], endtime: [], orderBy: ' workhours DESC' },//查询条件
      queryObjUserHoursDe: { pageNum: 1, pageSize: 20, starttime: [], endtime: [], orderBy: 'workhours DESC' },
      userHoursList: [],
      userHoursPageData: {},
      dateTimeRank: [],
      dateTimeDistrict: [],
      dateTimeUser: [],
      userTopThree: [],
      viewVisible: false,
      viewHourVisible: false,
      workAreaId: null,
      workAreaIdHour: null,
      loading: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.dateTimeRank = [dateutils.dateFormat("YYYY-mm-01", new Date()), dateutils.dateFormat("YYYY-mm-dd", new Date())]
      this.dateTimeDistrict = [dateutils.dateFormat("YYYY-mm-01", new Date()), dateutils.dateFormat("YYYY-mm-dd", new Date())]
      this.dateTimeUser = [dateutils.dateFormat("YYYY-mm-01", new Date()), dateutils.dateFormat("YYYY-mm-dd", new Date())]
      this.loaddistrictList();
      this.loadUserHoursList();
      this.loaduserListByDepartRank();
      this.loadAttendanceList();
    },
    //从后台查询线路列表
    loaddistrictList () {
      this.loading = true
      this.queryObj.starttime = this.dateTimeDistrict[0] + " 00:00:01"
      this.queryObj.endtime = this.dateTimeDistrict[1] + " 23:59:59"
      this.$ajax.get('/buss/statistic/districtList', this.queryObj).then(msg => {
        this.districtList = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    loadAttendanceList () {
      this.loading = true
      var param = new Object()
      param.starttime = this.dateTimeRank[0] + " 00:00:01"
      param.endtime = this.dateTimeRank[1] + " 23:59:59"
      param.orderBy = 'attendance DESC'
      this.$ajax.get('/buss/statistic/districtList', param).then(msg => {
        var dateValue = [];
        var dateKey = [];
        msg.forEach(element => {
          dateValue.push(element.attendance);
          dateKey.push(element.workAreaName);
        });
        this.initDepartCategoryEChart(dateKey, dateValue);
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loaduserListByDepart (workAreaId) {
      this.workAreaId = workAreaId;
      this.loading = true
      this.queryObjUser.starttime = this.dateTimeDistrict[0] + " 00:00:01"
      this.queryObjUser.endtime = this.dateTimeDistrict[1] + " 23:59:59"
      this.queryObjUser.workAreaId = workAreaId
      this.$ajax.get('/buss/statistic/userListByDepart', this.queryObjUser).then(msg => {
        this.userPageData = msg
        this.viewVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewVisible = false
        this.loading = false
      })
    },
    loaduserListByDepartRank () {
      this.loading = true
      var param = new Object()
      param.starttime = this.dateTimeRank[0] + " 00:00:01"
      param.endtime = this.dateTimeRank[1] + " 23:59:59"
      param.pageNum = 1
      param.pageSize = 3
      param.orderBy = 'workhours DESC'
      this.$ajax.get('/buss/statistic/userListByHoursAll', param).then(msg => {
        console.log('userTopThree', this.userTopThree)
        this.userTopThree = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    loadUserHoursList () {
      this.loading = true
      this.queryObjHours.starttime = this.dateTimeUser[0] + " 00:00:01"
      this.queryObjHours.endtime = this.dateTimeUser[1] + " 23:59:59"
      this.$ajax.get('/buss/statistic/userListByHours', this.queryObjHours).then(msg => {
        this.userHoursList = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    loadUserListByHoursDe (workAreaId) {
      this.workAreaIdHour = workAreaId;
      this.loading = true
      this.queryObjUserHoursDe.starttime = this.dateTimeUser[0] + " 00:00:01"
      this.queryObjUserHoursDe.endtime = this.dateTimeUser[1] + " 23:59:59"
      this.queryObjUserHoursDe.workAreaId = workAreaId
      this.$ajax.get('/buss/statistic/userListByHoursDe', this.queryObjUserHoursDe).then(msg => {
        this.userHoursPageData = msg
        this.viewHourVisible = true
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.viewHourVisible = false
        this.loading = false
      })
    },
    objectSpanMethod ({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    initDepartCategoryEChart (dateKey, dateValue) {
      this.$nextTick(() => {
        let myChart = this.$echarts.init(document.getElementById('hoursDate'))
        var option = {
          title: {
            text: '工区出勤率',
            textStyle: {
              color: '#040404',
              fontWeight: 'normal',
              fontSize: 16
            },
            padding: [5, 5, 5, 240] // 位置
          },
          grid: {
            show: false,
            top: '10%',
            right: '4%',
            bottom: '23%',
            left: '8%'
          },
          xAxis: {
            type: 'category',
            data: dateKey,
            axisLabel: {
              showMaxLabel: true,
              interval: 0,
              rotate: 40,
            }
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              barWidth: 20,
              type: 'bar',
              itemStyle: {
                normal: {
                  color: function (params) {
                    var colorList = ["#F86464", "#19DC7C", "#34A6FE", "#FA9022", "#DCDB01", "#8C70F8", "#2A4AD1", "#E76FE3", "#5032C0", "#168FB2"]
                    return colorList[params.dataIndex]
                  }
                }
              },
              data: dateValue
            }
          ]
        };
        myChart.setOption(option)
      })

    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.cbottom {
  width: 100%;
  height: 260px;
}

.tatistic-div {
  height: 85px;
  background: #c9e0f6;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-dialog-div {
  height: 100px;
  background: #c1c8fa;
  border-radius: 5px;
  margin-top: 10px;
  text-align: center;
}

.tatistic-value {
  color: rgb(68, 67, 67);
  margin-top: 6px;
  font-size: 24px;
}

.tatistic-key {
  color: rgb(126, 125, 125);
  margin-top: 10px;
  /* text-align: right; */
  font-size: 14px;
}

.context-icon {
  font-size: 40px;
  font-weight: 500;
  margin-top: 15px;
  margin-left: -60px;
}
</style>
